// eslint-disable-next-line import/no-cycle
import FilterPanel from './filterPanel';

export default FilterPanel;
